export const environment = {
    production: false,
    apiUrl: 'https://developapi.aslservices.com/'
  };
  